import React, { useState, useEffect } from 'react';
import { string } from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { LoadingPlaceholder } from '../../../../Placeholder/LoadingPlaceholder';

const FLAG_SIZE = 24;

export const LazyFlag = ({ countryCode }) => {
    const [flag, setFlag] = useState(null);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const importFlag = async () => {
            try {
                const { [countryCode.toLowerCase()]: importedFlag } = await import(
                    /* webpackChunkName: 'fit-circle-flags' */ '@fiverr-private/icons/circle-flags'
                );

                if (importedFlag) {
                    setFlag(importedFlag);
                } else {
                    setIsError(true);
                }
            } catch {
                setIsError(true);
            }
        };

        importFlag();
    }, [countryCode]);

    return isError ? null : (
        <LoadingPlaceholder ready={!!flag} type="round" className="flag-icon" width={FLAG_SIZE} height={FLAG_SIZE}>
            <Icon size={FLAG_SIZE} className="flag-icon">
                {flag}
            </Icon>
        </LoadingPlaceholder>
    );
};

LazyFlag.propTypes = {
    countryCode: string,
};

export default LazyFlag;
